module.exports = __webpack_public_path__ + "13bcd4f00ae5a66117b2d8b76c5252c1.png";